// extracted by mini-css-extract-plugin
export var actions = "_p6-5";
export var assistantBubble = "_p6-3";
export var assistantRow = "_p6-6";
export var bubble = "_p6-0";
export var humanAvatar = "_p6-4";
export var inlineToolCard = "_p6-1";
export var userBubble = "_p6-2";